export default "__VITE_ASSET__B4YE5ZJ6__"